export const tanstackTableNames = {
  contactAddresses: "contact-addresses-table",
  contactEmails: "contact-emails-table",
  contactFaxes: "contact-faxes-table",
  contactNotes: "contact-notes-table",
  contactPhones: "contact-phones-table",
  contactMatterConnections: "contact-matter-connections-table",
  contacts: "contacts-table",
  contactsSlideover: "contacts-slideover",
  contactTags: "contact-tags-table",
  contactWebsites: "contact-websites-table",
  dashboardApproachingStatutes: "dashboard-approaching-statutes-table",
  dashboardCreateTaskMatters: "dashboard-create-task-matters-table",
  dashboardPinnedMatters: "dashboard-pinned-matters-table",
  firmBusinessCards: "firm-business-cards-table",
  firmLawWorksCharges: "firm-lawworks-charges-table",
  firmPhones: "firm-phones-table",
  leadSources: "lead-sources-table",
  leadSourceMappings: "lead-source-mappings-table",
  matterDefaultFileRepositoryStructure:
    "matter-default-file-repository-structure-table",
  matterDefaultExpenses: "matter-default-expenses-table",
  matterEmails: "matter-emails-table",
  matterExpenses: "matter-expenses-table",
  matterIntakeResponses: "matter-intake-responses-table",
  matterSurveys: "matter-surveys-table",
  matterIntakeTemplates: "matter-intake-templates-table",
  matterLiens: "matter-liens-table",
  matterLawWorksCharges: "matter-lawworks-charges-table",
  medicalTreatmentBills: "medical-treatment-bills-table",
  medicalTreatmentRecords: "medical-treatment-records-table",
  medicalTreatmentPlans: "medical-treatment-plans-table",
  matterNotes: "matter-notes-table",
  matterRoles: "matter-roles-table",
  massTorts: "mass-torts-table",
  massTortCustomFields: "mass-tort-custom-fields-table",
  massTortMatters: "mass-tort-matters-table",
  massTortSurveys: "mass-tort-surveys-table",
  massTortSurveyMatterSelection: "mass-tort-survey-matter-selection-table",
  matters: "matters-table",
  myMattersDashboardTab: "my-matters-dashboard-tab-table",
  referrals: "referrals-table",
  mattersSlideover: "matters-slideover-table",
  matterLitigationDates: "matter-litigation-dates-table",
  matterShareFolderContacts: "matter-share-folder-contacts-table",
  matterStatutesOfLimitations: "matter-statutes-of-limitations-table",
  matterSettlementNegotiationsRounds:
    "matter-settlement-negotiations-rounds-table",
  matterStatuses: "matter-statuses-table",
  matterTags: "matter-tags-table",
  matterLitigationDateTypes: "matter-litigation-date-types-table",
  matterLitigationDatePlans: "matter-litigation-date-plans-table",
  matterLitigationDatePlanDates: "matter-litigation-date-plan-dates-table",
  matterTaskPlans: "matter-task-plans-table",
  phaseProjects: "phase-projects-table",
  matterScheduledMessages: "matter-scheduled-messages-table",
  matterTasks: "matter-tasks-table",
  matterPropertyDamage: "matter-property-damage-table",
  matterTeams: "matter-teams-table",
  matterContactSigners: "matter-contact-signers-table",
  matterSignatureRequestRecipients: "matter-signature-request-recipients-table",
  matterUserSigners: "matter-user-signers-table",
  matterTemplates: "matter-templates-table",
  incidentTypes: "matter-types-table",
  opportunities: "opportunities-table",
  phoneNumberSearch: "phone-number-search-table",
  reportsMatterActivity: "reports-matter-activity-table",
  reportsMatterDemand: "reports-matter-demand-table",
  reportsMatterRecordRequests: "reports-matter-record-requests-table",
  reportsMatterStatusCount: "reports-matter-status-count-table",
  mostRecentMatters: "most-recent-matters-table",
  reportsMatterSettlementReport: "reports-matter-settlement-report-table",
  reportsMatterSettlementDemands: "reports-matter-settlement-demands-table",
  reportsMatterSettlementOffers: "reports-matter-settlement-offers-table",
  reportsMatterSettlementTrustChecks:
    "reports-matter-settlement-trust-checks-table",
  reportsApproachingStatutes: "reports-approaching-statutes-table",
  reportsAttorneySummary: "reports-attorney-summary-table",
  reportsCaseAssignmentsCurrent: "reports-case-assignments-current-table",
  reportsCaseAssignmentsOverview: "reports-case-assignments-overview-table",
  reportsCaseAssignmentsFinancial: "reports-case-assignments-financial-table",
  reportsCaseAssignmentsClosed: "reports-case-assignments-closed-table",
  reportsClosedMatters: "reports-closed-matters-table",
  reportsDemandSummary: "reports-demand-summary-table",
  reportsOpenMatters: "reports-open-matters-table",
  reportsRoleAssignments: "reports-role-assignments-table",
  reportsSettlementSummaryIssues: "reports-settlement-summary-issues-table",
  reportsSettlementSummaryAwaiting: "reports-settlement-summary-awaiting-table",
  reportsSettlementSummaryWorkload: "reports-settlement-summary-workload-table",
  reportsSettlementSummaryClosed: "reports-settlement-summary-closed-table",
  reportsUserProductivity: "reports-user-productivity-table",
  test: "test-table",
  userGroups: "user-groups-table",
  users: "users-table",
} as const;
